import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import SectionMessage from '@atlaskit/section-message';
import { messages } from './messages';
export const ErrorState = () => /*#__PURE__*/React.createElement(SectionMessage, {
  appearance: "error"
}, /*#__PURE__*/React.createElement(FormattedMessage, messages.errorMessage));